export default __webpack_public_path__ + "static/media/tone.c247ef21.png";